import styled from '@emotion/styled'

export const StyledMaxWidthArea = styled.div`
  max-width: 600px;
  margin-inline: auto;
`

export const StyledList = styled.ul`
  list-style-type: disc !important;
  margin-left: 16px;
  lin-height: 1.5em;
  li {
    margin-bottom: 8px;
  }
`
